import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    baseUrl: String,
    guardia: Boolean
  }

  connect() {
    this.findSearchController();
  }

  findSearchController() {
    const controllerName = this.guardiaValue ? 'search-pacientes-guardia' : 'search-pacientes';
    const searchElement = document.querySelector(`[data-controller*="${controllerName}"]`);
    if (searchElement) {
      try {
        this.searchController = this.application.getControllerForElementAndIdentifier(
          searchElement,
          controllerName
        );
      } catch (e) {
        console.error('No se encontró el controlador', e);
      }
    }
  }

  async download(event) {
    event.preventDefault();
    event.stopPropagation();
    
    document.dispatchEvent(new CustomEvent('spinner:show'));

    try {
      if (!this.searchController) {
        this.findSearchController();
      }

      if (!this.searchController) {
        console.error('No se encontró el controlador');
        return;
      }

      const params = new URLSearchParams();

      if (this.guardiaValue) {
        params.append('guardia', 'true');
        
        const searchInputValue = this.searchController.searchInputTarget?.value;
        const allGuardiaCheckboxValue = this.searchController.allGuardiaCheckboxTarget?.checked || false;
        const obraSocialValue = this.searchController.obraSocialTarget?.value;
        const desdeValue = this.searchController.desdeTarget?.value;
        const hastaValue = this.searchController.hastaTarget?.value;

        if (searchInputValue && searchInputValue.trim() !== '') {
          params.append('q_guardia', searchInputValue.trim());
        }
        if (allGuardiaCheckboxValue === true) {
          params.append('all_guardia', 'true');
        }
        if (obraSocialValue && obraSocialValue !== '' && obraSocialValue !== 'Obra social') {
          params.append('obra_social_guardia', obraSocialValue);
        }
        if (desdeValue && desdeValue.trim() !== '') {
          params.append('desde_guardia', desdeValue.trim());
        }
        if (hastaValue && hastaValue.trim() !== '') {
          params.append('hasta_guardia', hastaValue.trim());
        }
      } else {
        const searchInputValue = this.searchController.searchInputTarget?.value;
        const allCheckboxValue = this.searchController.allCheckboxTarget?.checked || false;
        const sectorValue = this.searchController.sectorTarget?.value;
        const obraSocialValue = this.searchController.obraSocialTarget?.value;
        const tipoValue = this.searchController.tipoTarget?.value;
        const desdeValue = this.searchController.desdeTarget?.value;
        const hastaValue = this.searchController.hastaTarget?.value;

        if (searchInputValue && searchInputValue.trim() !== '') {
          params.append('q', searchInputValue.trim());
        }
        if (allCheckboxValue === true) {
          params.append('all', 'true');
        }
        if (sectorValue && sectorValue !== '' && sectorValue !== 'Sector') {
          params.append('sector', sectorValue);
        }
        if (obraSocialValue && obraSocialValue !== '' && obraSocialValue !== 'Obra social') {
          params.append('obra_social', obraSocialValue);
        }
        if (tipoValue && tipoValue !== '' && tipoValue !== 'Tipo') {
          params.append('tipo', tipoValue);
        }
        if (desdeValue && desdeValue.trim() !== '') {
          params.append('desde', desdeValue.trim());
        }
        if (hastaValue && hastaValue.trim() !== '') {
          params.append('hasta', hastaValue.trim());
        }
      }

      const url = `${this.baseUrlValue || '/pacientes/download_excel'}?${params.toString()}`;
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error('Error al descargar el archivo');
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `pacientes_${new Date().toISOString().slice(0, 10)}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      alert('Error al descargar el archivo Excel');
    } finally {
      document.dispatchEvent(new CustomEvent('spinner:hide'));
    }
  }
}

